module.exports = __webpack_public_path__ + "img/slider2.ec856c34.gif";